import { useEffect, useRef, useState } from "react";

/**
 * useScrollReveal — adds `in-view` class on the element ref when it enters
 * the viewport. Pair with the `.reveal-up` utility in index.css.
 */
export function useScrollReveal({ threshold = 0.15, once = true } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            el.classList.add("in-view");
            if (once) obs.unobserve(el);
          } else if (!once) {
            setInView(false);
            el.classList.remove("in-view");
          }
        });
      },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold, once]);

  return { ref, inView };
}
